import { createConsumer } from "@rails/actioncable";
import { camelizeKeys, decamelizeKeys } from "humps";

class Channel {
  constructor({ channelName, params }, handlers = {}) {
    const consumer = createConsumer(this.connectUrl);

    const DEFAULT_HANDLERS = {
      received: () => console.log(channelName + " received"),
      connected: () => console.log(channelName + " connected"),
      rejected: () => console.log(channelName + " rejected"),
      disconnected: () => console.log(channelName + " disconnected"),
    };

    const usedHandlers = Object.assign({}, DEFAULT_HANDLERS, handlers);

    this._channel = consumer.subscriptions.create(
      {
        channel: channelName,
        ...params,
      },
      {
        ...usedHandlers,
        received: (data) => usedHandlers.received(camelizeKeys(data)),
      }
    );
  }

  get connectUrl() {
    const jwtToken = localStorage.getItem("token");
    if (!jwtToken) throw new Error("Has not session token");
    const connectParams = [`token=${jwtToken}`, "role=consultant"].join("&");
    return `${process.env.REACT_APP_WEBSOCKET_URL}?${connectParams}`;
  }

  perform = (action, data = {}) => {
    if (!this._channel) return;
    return this._channel.perform(action, decamelizeKeys(data));
  };

  dispose = () => {
    this._channel.unsubscribe();
    this._channel = null;
  };
}

export default Channel;
